export default __webpack_public_path__ + "static/media/GRE.acaefe4b.png";